import * as React from 'react'
import * as styles from './Header.module.scss'
import { Link } from 'DVWebNodeUI'
import Facet from './Facet'
import SeeMore from './SeeMore'
import * as cn from 'classnames'
import { FeatureSwitches } from '../../../../containers/Storefront';
import { StorefrontCarouselEditInfo, StorefrontLink } from 'DVWebNodeUtils';

const ELLIPSIS_PADDING = 30

interface HeaderProps {
  featureSwitches?: FeatureSwitches
  noMarginLeft?: boolean
  hasAltTheme?: boolean
  facetType?: string
  facetText?: string
  facetAlternateText?: string
  facetImage?: string
  text?: string
  seeMoreLink?: StorefrontLink
  seeMoreDescription?: string
  edit?: StorefrontCarouselEditInfo
  toggleEdit?: Function
  isEditActive?: boolean
  subtext?: string
  shortTitleWidth?: number
  isPhablet?: boolean
}

const Header = (props: HeaderProps) => (
  <div className={cn(styles.Header,
    { [styles.noMarginLeft]: props.noMarginLeft },
    { [styles.AltTheme]: props.hasAltTheme })}>
    <div className={cn(styles.Line1, { [styles.phablet]: props.isPhablet })}
      style={{ width: props.shortTitleWidth - ELLIPSIS_PADDING || 'auto' }}>
      <Facet {...props} className={styles.Line1Content} />
      <div className={cn(styles.Line1Content, {
        [styles.carouselNameRow]: props.shortTitleWidth === 0,
        [styles.shortTitleRow]: props.shortTitleWidth > 0,
        [styles.hasEdit]: Boolean(props.edit)
      })}>
        {props.text && (
          <h2 className={styles.title}>
            {props.text}
          </h2>
        )}
        <SeeMore {...props.seeMoreLink}
          hasAltTheme={props.hasAltTheme}
          description={props.seeMoreDescription} />
        {Boolean(props.edit) &&
          (
            <Link className={cn(styles.Edit, 'tst-edit-button')}
              onClick={() => props.toggleEdit()}>
              {!props.isEditActive ? props.edit.label
                : props.edit.cancelLabel}
            </Link>
          )
        }
      </div>
    </div>
    <div className={styles.Line2}>
      {props.subtext && (
        <h3 className={styles.subtitle}>
          {props.subtext}
        </h3>
      )}
    </div>
  </div>
)

export default Header
